module.exports = __webpack_public_path__ + "img/xst.5dace3a4.svg";